// Models
import { IAnamneseAnswerState } from 'storage/assessmentAnamneseAnswer/models'
import { IProfileState } from 'storage/profile/models'
import IStore from 'lib/redux/models'

// React
import { FC, useContext, useEffect, useLayoutEffect } from 'react'

// Libs
import { ThemeContext } from 'styled-components'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

// Misc
import { buttonClickTracking } from 'utils/tracking'
import { triggerGetAnamneseAnswer } from 'storage/assessmentAnamneseAnswer/duck'
import { urls } from 'routes/paths'
import { useMediaQuery, useMenu } from 'hooks'

// Components
import * as Styled from './styled'
import { Aligner } from 'heeds-ds'
import { AnamnesePreview } from 'components'
import { PdfDownloadButton } from 'components'
import StatementOfResponsibilityPDF from 'components/PDFs/StatementOfResponsibilityPDF'
import { triggerToast } from 'storage/general/duck'

const AthleteAssessmentAnamneseAnswer: FC = () => {
  const { anamnese_id, id = '' } = useParams()
  const { profile } = useSelector<IStore, IProfileState>(
    ({ profile }) => profile,
  )
  const { anamneseAnswer, loading } = useSelector<IStore, IAnamneseAnswerState>(
    ({ assessmentAnamneseAnswer }) => assessmentAnamneseAnswer,
  )
  const { setPagename } = useMenu()
  const dispatch = useDispatch()
  const theme = useContext(ThemeContext)
  const isDesktop = useMediaQuery(
    `(min-width: ${theme.breakpoints.desktopSmall}px)`,
  )
  const navigate = useNavigate()

  const handleGoBack = (replace?: boolean) =>
    navigate(generatePath(urls.athleteAssessmentAnamneseAnswers, { id }), {
      replace,
    })

  useLayoutEffect(() => {
    if (!anamneseAnswer && anamnese_id && !loading) {
      dispatch(triggerGetAnamneseAnswer(anamnese_id))
    }
  }, [dispatch, anamneseAnswer, anamnese_id, loading])

  useLayoutEffect(() => {
    setPagename('Anamnese')

    return () => {
      setPagename('Anamneses')
    }
  }, [setPagename])

  useEffect(() => {
    if (loading === false && !anamneseAnswer?.answer_date) {
      const isSystemAssessment = anamneseAnswer?.personal === 0
      dispatch(
        triggerToast(
          isSystemAssessment
            ? {
                type: 'info',
                customTitle:
                  'Formulário enviado automaticamente para o seu aluno.',
                message:
                  'Não se preocupe, após o cadastro seu aluno já terá acesso a esse formulário.',
              }
            : {
                type: 'warning',
                customTitle: 'Questionário ainda não respondido.',
                message:
                  'Você receberá um aviso quando esse questionário for respondido',
              },
        ),
      )
    }
  }, [anamneseAnswer, dispatch, loading])

  return (
    <Styled.Container>
      {isDesktop && (
        <Aligner justify="space-between">
          <Styled.GoBackButton
            onClick={() => handleGoBack()}
            track={buttonClickTracking}
            trackName="navigate_back_to_assessments"
          >
            <Styled.GoBackIcon />
            Voltar para avaliações
          </Styled.GoBackButton>
          {/* TODO: modificar quando for decidido como serao esses formularios do sistema */}
          {anamneseAnswer?.id === 'parq' && (
            <PdfDownloadButton
              buttonName="Baixar termo de responsabilidade"
              fileName="termos_de_responsabilidade_cadu"
              PDF={
                <StatementOfResponsibilityPDF
                  data={{
                    cref: profile?.crefs ? profile.crefs[0].register : '',
                    name: profile?.name ?? '',
                  }}
                />
              }
              size="small"
            />
          )}
        </Aligner>
      )}

      <AnamnesePreview anamnese={anamneseAnswer} loading={loading} />
    </Styled.Container>
  )
}

export default AthleteAssessmentAnamneseAnswer
